import styled from 'styled-components';
import ArrowRight from '../../../assets/img/ArrowRight';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  .card-content {
    display: flex;
    flex-direction: column;
    margin-left: 16px;
  }
  p {
    margin: 0;
  }
  .card-title {
    color: #001823;
    font-family: Roboto Slab;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    margin-bottom: 12px;
    width: 298px;
  }
  .card-description {
    color: #001823;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    width: 311px;
  }
  .arrow-icon {
    position: absolute;
    bottom: -22px;
    right: -32px;
    padding: 0;
    margin: 0;
    cursor: pointer;
  }
`;
interface RedirectionCardProps {
  title: React.ReactChild;
  description: string;
  image: React.ReactChild;
}
const SettingRedirectionCard: React.FC<RedirectionCardProps> = ({ title, description, image }) => {
  return (
    <Wrapper>
      <div>
        {/* <Xelator /> */}
        {image}
      </div>
      <div className="card-content">
        <p className="card-title">{title}</p>
        <p className="card-description">{description}</p>
      </div>
      <span className="arrow-icon">
        <ArrowRight />
      </span>
    </Wrapper>
  );
};

export default SettingRedirectionCard;
